import { CommandType } from "../../../../common/services/cqs/CommandType";
import { Kontrakt } from "../../models/kontrakt-models";
import { KontraktCommandBase } from "./KontraktCommandBase";

export class ChangeKontraktTypCommand extends KontraktCommandBase {
    readonly kontraktstyp: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ChangeKontraktTypCommand";

    constructor(avtalGuid: string, kontrakt: Kontrakt) {
        super(avtalGuid, kontrakt.guid, ChangeKontraktTypCommand.$type, CommandType.Replace);
        this.kontraktstyp = kontrakt.kontraktTyp;
    }
}
